import React, {useState} from "react";
import {Lot, Reserve} from "../types/Types";
import ApiHelper from "../../api/ApiHelper";
import {useAlert} from "react-alert";


interface BYExportButtonsProps {
    selectedReserves: Lot[] | Reserve[];
    type: 'lot' | 'reserve';
    selectedPhases: number[];
}

const validateMaxNumberOfSelectedRows = (rows, limit = 2000) => {
    if (rows.length > limit) {
        throw new Error(`${limit} lignes maximum (${rows.length} sélectionnés).\nEssayez de filtrer par Phase, Bâtiment, etc.`);
    }
}

const BYExportButtons = ({selectedReserves, selectedPhases, type}: BYExportButtonsProps) => {
    const [loading, setLoading] = useState(false);
    const [exportByEnterprise, setExportByEnterprise] = useState(false);
    const [exportNonLeve, setExportNonLeve] = useState(false);

    const alert = useAlert();

    return <div className="form-inline d-inline-flex">
        <div className="btn-group btn-group-sm">
            <button type="button" className="btn btn-sm btn-primary"
                    disabled={loading || !selectedReserves.length}
                    onClick={async () => {
                        setLoading(true);

                        try {
                            validateMaxNumberOfSelectedRows(selectedReserves, type === 'lot' ? 100: 2000);

                            if (type === 'lot') {
                                await ApiHelper.getLotsPdf(selectedReserves.map(r => r.refLot), {phases: selectedPhases, exportByEnterprise, exportNonLeve});
                            } else if (type === 'reserve') {
                                await ApiHelper.getReservesPdf(selectedReserves.map(r => r.refReserve), {phases: selectedPhases, exportByEnterprise, exportNonLeve});
                            }
                        } catch (e) {
                            alert.error(e.message);
                        }
                        setLoading(false);
                    }}>
                <i className="fa fa-print"></i>
            </button>
            <button type="button" className="btn btn-sm btn-secondary"
                    disabled={loading || !selectedReserves.length}
                    onClick={async () => {
                        setLoading(true);

                        try {
                            validateMaxNumberOfSelectedRows(selectedReserves);

                            if (type === 'lot') {
                                await ApiHelper.getLotsCsv(selectedReserves.map(r => r.refLot));
                            } else if (type === 'reserve') {
                                await ApiHelper.getReservesCsv(selectedReserves.map(r => r.refReserve));
                            }
                        } catch (e) {
                            alert.error(e.message);
                        }
                        setLoading(false);
                    }}>
                <i className="fa fa-file-excel"></i>
            </button>
        </div>
        <div className="form-check ml-2">
            <input
                className="form-check-input"
                type="checkbox"
                name="indicActif"
                checked={exportByEnterprise}
                onChange={(e) => setExportByEnterprise(e.target.checked)}
                id="flexCheckDefault"
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
                {' '}Exporter par entreprise
            </label>
            {loading && <div className="spinner-grow spinner-grow-sm ml-1 color-green" role="status">
                                <span className="sr-only">Loading...</span>
            </div>}
        </div>
        <div className="form-check ml-2">
            <input
                className="form-check-input"
                type="checkbox"
                name="indicActif"
                checked={exportNonLeve}
                onChange={(e) => setExportNonLeve(e.target.checked)}
                id="flexCheckDefault"
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
                {' '}Non levée
            </label>
            {loading && <div className="spinner-grow spinner-grow-sm ml-1 color-green" role="status">
                                <span className="sr-only">Loading...</span>
            </div>}
        </div>
    </div>;
};

export default BYExportButtons;
